module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-card shadow-sm h-100 p-3 position-relative overflow-hidden",
    style: ({
      borderLeft: '4px solid ' + _vm.color
    })
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    staticStyle: {
      "color": "grey !important"
    },
    attrs: {
      "small": "",
      "variant": 'primary'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'loading-blur': _vm.loading
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_c('p', {
    staticClass: "text-muted small mb-1"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h3', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.value))])]), _vm._v(" "), _c('div', {
    staticClass: "icon-box",
    style: ({
      backgroundColor: _vm.color + '22',
      color: _vm.color
    })
  }, [_c('md-icon', [_vm._v(_vm._s(_vm.icon))])], 1)]), _vm._v(" "), (_vm.trend !== undefined) ? _c('p', {
    staticClass: "small mb-0",
    class: _vm.trend >= 0 ? 'text-success' : 'text-danger'
  }, [_c('md-icon', {
    staticClass: "v-align-middle",
    attrs: {
      "size": "16"
    }
  }, [_vm._v(_vm._s(_vm.trend >= 0 ? 'trending_up' : 'trending_down'))]), _vm._v("\n      " + _vm._s(Math.abs(_vm.trend)) + "% from last month\n    ")], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a62723a2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/VehiclePerformanceDashboard/components/KpiCard.vue
// module id = 2825
// module chunks = 0